import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
	contactsHeader: {
		display: "flex",
		alignItems: "center",
		padding: "0px 6px 6px 6px",
		background: "var(--app-body-bg, transparent)",
		color: "var(--app-text, inherit)",
	},
}));

function MainHeader({ children }) {
	const classes = useStyles();

	return <div className={classes.contactsHeader}>{children}</div>;
}

export default MainHeader;
